module.exports = __webpack_public_path__ + "media/8.ba36fe0f.mp3";